import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { GenericModel } from '@nsk-app/models/genericModel';

@Entity({
  orderBy: {
    created_at: 'DESC'
  }
})
export class News extends GenericModel {

  @Column()
  title: string;

  @Column()
  text: string;

  @Column()
  image: string;

}
